export default __webpack_public_path__ + "static/media/p06 p01.7e6f7021.jpg";